import { IdbStorage } from "@icp-sdk/auth/client";
import { SignIdentity } from "@icp-sdk/core/agent";
import { DelegationChain, DelegationIdentity, ECDSAKeyIdentity, isDelegationValid, } from "@icp-sdk/core/identity";
const KEY_STORAGE_AUTH_PRINCIPAL = "auth_principal";
const KEY_STORAGE_KEY = "identity";
const KEY_STORAGE_DELEGATION = "delegation";
export class IdentityStorage {
    storage;
    constructor(dbName) {
        this.storage = new IdbStorage({ dbName });
    }
    static createForAuthIdentity() {
        return new IdentityStorage("auth-client-db");
    }
    static createForOcIdentity() {
        return new IdentityStorage("oc-auth-db");
    }
    async get(authPrincipal) {
        const keyAndChain = await this.getKeyAndChain(authPrincipal);
        return keyAndChain === undefined
            ? undefined
            : DelegationIdentity.fromDelegation(keyAndChain.key, keyAndChain.delegation);
    }
    async getKeyAndChain(authPrincipal) {
        if (authPrincipal !== undefined) {
            const storedAuthPrincipal = await this.storage.get(KEY_STORAGE_AUTH_PRINCIPAL);
            if (storedAuthPrincipal == null)
                return undefined;
            if (storedAuthPrincipal !== authPrincipal) {
                this.remove();
                return undefined;
            }
        }
        const cryptoKey = await this.storage.get(KEY_STORAGE_KEY);
        if (cryptoKey == null)
            return undefined;
        const chainJson = await this.storage.get(KEY_STORAGE_DELEGATION);
        if (chainJson == null)
            return undefined;
        const delegationChain = DelegationChain.fromJSON(chainJson);
        if (!isDelegationValid(delegationChain)) {
            this.remove();
            return undefined;
        }
        const key = await ECDSAKeyIdentity.fromKeyPair(cryptoKey);
        return {
            key,
            delegation: delegationChain,
        };
    }
    async set(key, chain, authPrincipal) {
        if (authPrincipal !== undefined) {
            await this.storage.set(KEY_STORAGE_AUTH_PRINCIPAL, authPrincipal);
        }
        await this.storage.set(KEY_STORAGE_KEY, key.getKeyPair());
        await this.storage.set(KEY_STORAGE_DELEGATION, JSON.stringify(chain.toJSON()));
    }
    async remove() {
        await this.storage.remove(KEY_STORAGE_AUTH_PRINCIPAL);
        await this.storage.remove(KEY_STORAGE_KEY);
        await this.storage.remove(KEY_STORAGE_DELEGATION);
    }
}
